import { render, staticRenderFns } from "./CrudVolunteers.vue?vue&type=template&id=301ae814&"
import script from "./CrudVolunteers.vue?vue&type=script&lang=js&"
export * from "./CrudVolunteers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports